// @todo: Migrate to 'DropdownMenu' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {PopupDropdown} from '@wandb/weave/common/components/PopupDropdown';
// @todo: Migrate to @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {IconDelete} from '@wandb/weave/components/Icon';
import React from 'react';
// @todo: Migrate to 'Link' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Link} from 'react-router-dom';

import {Analytics} from '../../../services/analytics';
import {job as jobUrl} from '../../../util/urls';
import * as S from './JobsTableActions.styles';

type JobsTableActionsProps = {
  entityName: string;
  projectName: string;
  jobId: string;
  jobName: string;
  jobVersion: string | null;
  versionCount: number;
  onRun: (jobId: string, jobEntityName: string, jobProjectName: string) => void;
  onDelete: (jobId: string, jobName: string) => void;
  jobEntityName: string;
  jobProjectName: string;
};

export const JobsTableActions = ({
  entityName,
  projectName,
  jobId,
  jobName,
  jobVersion,
  versionCount,
  onRun,
  onDelete,
  jobEntityName,
  jobProjectName,
}: JobsTableActionsProps) => {
  const urlParams = {
    entityName: jobEntityName,
    projectName: jobProjectName,
    jobId,
    jobVersion,
    tab: versionCount ? 'runs' : 'job_details',
  };
  const jobLink = jobUrl(urlParams);

  const onLaunchClick = (e: React.MouseEvent) => {
    onRun(jobId, jobEntityName, jobProjectName);
    Analytics.track('clicked launch button', {
      entityName,
      jobId,
      location: 'job table',
    });
  };

  const menuOptions = [
    {
      key: 'delete-job',
      text: 'Delete job',
      icon: <IconDelete style={{marginRight: '4px'}} />,
      onClick: () => {
        Analytics.track('clicked delete job', {
          entityName,
          location: 'job table',
        });
        onDelete(jobId, jobName);
      },
    },
  ];

  const showDelete =
    entityName === jobEntityName && projectName === jobProjectName;

  return (
    <S.Buttons>
      <Button
        data-test="launch-job-button"
        style={{marginRight: 8}}
        variant="ghost"
        disabled={!jobVersion}
        onClick={onLaunchClick}
        tooltip="Configure and launch this job">
        Launch
      </Button>
      <div style={{marginRight: 8}}>
        <Link
          to={jobLink}
          onClick={() => {
            Analytics.track('clicked view job', {
              entityName,
              jobLink,
              location: 'job table',
            });
          }}>
          <Button variant="ghost" tooltip="View job details">
            View
          </Button>
        </Link>
      </div>
      <div>
        {showDelete && (
          <PopupDropdown
            position="bottom right"
            trigger={<Button icon="overflow-horizontal" variant="ghost" />}
            options={menuOptions}
          />
        )}
      </div>
    </S.Buttons>
  );
};
